export const environment = {
  production: false,
  appVersion: '2026.05.31-dev',
  firebase: {
        apiKey: "AIzaSyAu_9bBX__NHdqxrcdE_wFwBPfJxAD6RWY",
        authDomain: "scheduler-dev-ba560.firebaseapp.com",
        projectId: "scheduler-dev-ba560",
        storageBucket: "scheduler-dev-ba560.firebasestorage.app",
        messagingSenderId: "1008551990483",
        appId: "1:1008551990483:web:63394d3a0d27aa3c653026"
  },
  geminiApiKey: "AIzaSyClRYep0sJorfusQtIEfZbqryXY9IbCJ68",
  // Get your VAPID key from Firebase Console:
  // 1. Go to Project Settings
  // 2. Click on "Cloud Messaging" tab
  // 3. Under "Web Push certificates", copy the public key (starts with "B")
  vapidKey: "", // Leave empty to disable push notifications, or paste your VAPID key here
  // Demo credentials for development
  demoCredentials: {
    email: "sunil@email.com",
    password: "Sunil@1234"
  }
};
